var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LineChart } from '@tremor/react';
import { ExportMenu } from '@web/components/layout/ExportMenu/ExportMenu';
import Loading from '@web/components/layout/Loading';
import Table from '@web/components/layout/Table/Table';
import { widgetMetricTableChartTdClass, widgetMetricTableColMetricValueStyle, widgetMetricTableFigureValueSpanClass, widgetMetricTablePairHeaderThClass, widgetMetricTablePrimaryLabelTdClass, widgetMetricTableValueCellInnerClass, widgetMetricTableValueTdClass } from '@web/components/layout/WidgetTable/widgetMetricCellClasses';
import { metricTablePeriodDiffRowCell } from '@web/components/layout/WidgetTable/widgetMetricTableCells';
import { WidgetTitle } from '@web/components/layout/WidgetTitle/WidgetTitle';
import { EmailSummaryReplyRate } from '@web/components/PerformanceReview/Employee/Sections/Communication/EmailSummaryReplyRate';
import { SentVSReceivedRatio } from '@web/components/PerformanceReview/Employee/Sections/Communication/SentVSReceivedRatio';
import { TablesDiffColorsConfig, WIDGET_LINE_CHART_GREEN } from '@web/config';
import { trpc } from '@web/lib/trpc';
import { classNames, getApplicationIconByType, isAiButtonDisabled, isInsightsDataEmpty } from '@web/utility';
import { createGetDotColorClass, getBarChartTooltip } from '@web/utility/ tooltip/tremorTooltip';
import { navigateToChartDestination } from '@web/utility/chartNavigation';
import { useNavigateTo } from '@web/utility/hooks/useNavigateTo';
import { ApplicationEnum, InitiatedCommunicationByChannel, ReceivedCommunicationByChannel } from '@workalizer/shared';
import { InsightTypeEnum } from '@workalizer/shared/enums';
import { format, parseISO } from 'date-fns';
import { enUS } from 'date-fns/locale';
import { useTranslation } from 'react-i18next';
var communicationByChannelTrendChartCol = {
    width: '42%',
    minWidth: '12rem'
};
var communicationByChannelTrendChartColWide = {
    width: '58%',
    minWidth: '14rem'
};
var communicationByChannelColgroupDoublePair = [
    { width: '22%', minWidth: '10.5rem' },
    communicationByChannelTrendChartCol,
    widgetMetricTableColMetricValueStyle,
    { width: '13%', minWidth: '5.25rem' },
    widgetMetricTableColMetricValueStyle,
    { width: '13%', minWidth: '5.25rem' }
];
var communicationByChannelColgroupSinglePair = [
    { width: '22%', minWidth: '10.5rem' },
    communicationByChannelTrendChartColWide,
    widgetMetricTableColMetricValueStyle,
    { width: '13%', minWidth: '5.25rem' }
];
function communicationByChannelTableClassName(userId) {
    return classNames('w-full table-auto', userId ? 'min-w-[72rem]' : 'min-w-[52rem]');
}
var getCommunicationChannelApp = function (channel) {
    switch (channel) {
        case InitiatedCommunicationByChannel.EMAILS_SENT:
        case ReceivedCommunicationByChannel.EMAILS_RECEIVED:
            return ApplicationEnum.GMAIL;
        case InitiatedCommunicationByChannel.CHATS_MESSAGES_POSTED:
        case ReceivedCommunicationByChannel.CHATS_MESSAGES_RECEIVED:
        case InitiatedCommunicationByChannel.CHATS_MESSAGES_REACTIONS:
        case ReceivedCommunicationByChannel.CHATS_REACTIONS_RECEIVED:
            return ApplicationEnum.CHAT;
        case InitiatedCommunicationByChannel.MEETINGS_ORGANIZED:
        case ReceivedCommunicationByChannel.MEETINGS_PARTICIPATED:
            return ApplicationEnum.MEET;
        case InitiatedCommunicationByChannel.DOCS_COMMENTS_ADDED:
        case ReceivedCommunicationByChannel.DOCS_COMMENTS_RECEIVED:
            return ApplicationEnum.DRIVE;
        default:
            return null;
    }
};
function CommunicationChannelTrendChart(_a) {
    var daily = _a.daily, channelMetricLabel = _a.channelMetricLabel, referenceDateFrom = _a.referenceDateFrom, referenceDateTo = _a.referenceDateTo, onDayClick = _a.onDayClick;
    var getDotColorClass = createGetDotColorClass({
        categories: [channelMetricLabel],
        colors: [WIDGET_LINE_CHART_GREEN]
    });
    return (_jsx("div", __assign({ className: "min-w-[12rem] w-full max-w-none cursor-pointer" }, { children: _jsx(LineChart, { data: daily.map(function (d) {
                var _a;
                return (_a = {
                        date: d.date
                    },
                    _a[channelMetricLabel] = d.count,
                    _a);
            }), index: "date", categories: [channelMetricLabel], showLegend: false, showYAxis: false, showXAxis: false, startEndOnly: true, className: "h-20 min-h-[4.5rem] w-full pb-6", colors: [WIDGET_LINE_CHART_GREEN], curveType: "monotone", customTooltip: function (props) {
                return getBarChartTooltip(props, [channelMetricLabel], {
                    getDotColorClass: getDotColorClass,
                    referenceDateFrom: referenceDateFrom,
                    referenceDateTo: referenceDateTo
                });
            }, onValueChange: function (event) {
                var day = event === null || event === void 0 ? void 0 : event.date;
                if (typeof day === 'string' && day) {
                    onDayClick(day);
                }
            } }) })));
}
function buildCommunicationChannelTableRows(_a) {
    var items = _a.items, idPrefix = _a.idPrefix, userId = _a.userId, dateFrom = _a.dateFrom, dateTo = _a.dateTo, navigateToChannelEventsLog = _a.navigateToChannelEventsLog, t = _a.t;
    return items.map(function (item) {
        var channelMetricLabel = t("app.performanceReview.employeePerformanceReview.communicationSection.tablesData.channelNames.".concat(item.channel));
        var navigateToPeriodEventsLog = function () {
            return navigateToChannelEventsLog(item.channel, dateFrom, dateTo);
        };
        var channelApp = getCommunicationChannelApp(item.channel);
        var channelIcon = channelApp
            ? getApplicationIconByType(channelApp)
            : null;
        var row = [
            {
                id: "".concat(idPrefix, "-channel-").concat(item.channel),
                className: widgetMetricTablePrimaryLabelTdClass,
                render: function () { return (_jsxs("div", __assign({ className: "flex min-w-0 max-w-full cursor-pointer items-center gap-2", onClick: navigateToPeriodEventsLog }, { children: [_jsx("span", __assign({ className: "shrink-0" }, { children: channelIcon })), _jsx("span", __assign({ className: "min-w-0 break-words font-semibold" }, { children: channelMetricLabel }))] }))); }
            },
            {
                id: "".concat(idPrefix, "-chart-").concat(item.channel),
                className: widgetMetricTableChartTdClass,
                render: function () { return (_jsx(CommunicationChannelTrendChart, { daily: item.daily, channelMetricLabel: channelMetricLabel, referenceDateFrom: dateFrom, referenceDateTo: dateTo, onDayClick: function (day) {
                        return navigateToChannelEventsLog(item.channel, day, day);
                    } })); }
            },
            {
                id: "".concat(idPrefix, "-count-value-").concat(item.channel),
                className: classNames(widgetMetricTableValueTdClass, 'cursor-pointer'),
                render: function () { return (_jsx("div", __assign({ className: classNames(widgetMetricTableValueCellInnerClass, 'cursor-pointer'), onClick: navigateToPeriodEventsLog }, { children: _jsx("span", __assign({ className: widgetMetricTableFigureValueSpanClass }, { children: item.count })) }))); }
            },
            metricTablePeriodDiffRowCell("".concat(idPrefix, "-count-prev-").concat(item.channel), item.userPrevPeriodDiff, TablesDiffColorsConfig.GREEN)
        ];
        if (userId) {
            row.push({
                id: "".concat(idPrefix, "-avg-value-").concat(item.channel),
                className: widgetMetricTableValueTdClass,
                render: function () { return (_jsx("div", __assign({ className: widgetMetricTableValueCellInnerClass }, { children: _jsx("span", __assign({ className: widgetMetricTableFigureValueSpanClass }, { children: item.avg })) }))); }
            }, metricTablePeriodDiffRowCell("".concat(idPrefix, "-avg-prev-").concat(item.channel), item.avgPrevPeriodDiff, TablesDiffColorsConfig.BLUE));
        }
        return row;
    });
}
function toCommunicationChannelTableItems(items) {
    return items.map(function (item) { return ({
        channel: item.channel,
        count: 'total' in item ? item.total : item.count,
        userPrevPeriodDiff: item.userPrevPeriodDiff,
        avg: item.avg,
        avgPrevPeriodDiff: item.avgPrevPeriodDiff,
        daily: item.daily
    }); });
}
export var CommunicationByChannelSection = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j;
    var userId = _a.userId, orgUnitId = _a.orgUnitId, dateFrom = _a.dateFrom, dateTo = _a.dateTo;
    var t = useTranslation().t;
    var navigateTo = useNavigateTo();
    var navigateToChannelEventsLog = function (channel, rangeFrom, rangeTo) {
        navigateToChartDestination({
            kind: 'eventsLog',
            app: getCommunicationChannelApp(channel)
        }, {
            navigateTo: navigateTo,
            dateFrom: rangeFrom,
            dateTo: rangeTo,
            userId: userId,
            orgUnitId: orgUnitId
        });
    };
    var _k = trpc.communicationByChannel.useQuery({
        userId: userId,
        orgUnitId: orgUnitId,
        dateFrom: dateFrom,
        dateTo: dateTo
    }), communicationByChannel = _k.data, isLoading = _k.isLoading, refetch = _k.refetch;
    if (isLoading) {
        return _jsx(Loading, {});
    }
    var channelTableColStyles = userId
        ? communicationByChannelColgroupDoublePair
        : communicationByChannelColgroupSinglePair;
    function buildChannelExportRows(items) {
        var periodLabel = formatPeriod(dateFrom, dateTo);
        var channelLabel = t('app.performanceReview.employeePerformanceReview.communicationSection.tablesData.channel');
        var avgLabel = t('app.performanceReview.employeePerformanceReview.communicationSection.tablesData.avgPerEmployee');
        return items.map(function (item) {
            var _a;
            var countValue = 'total' in item ? item.total : item.count;
            return _a = {},
                _a[t('filters.period')] = periodLabel,
                _a[channelLabel] = t("app.performanceReview.employeePerformanceReview.communicationSection.tablesData.channelNames.".concat(item.channel)),
                _a.Count = countValue,
                _a[avgLabel] = item.avg,
                _a;
        });
    }
    function formatPeriod(dateFrom, dateTo) {
        var fromDate = parseISO(dateFrom);
        var toDate = parseISO(dateTo);
        var fromLabel = format(fromDate, 'MMM d', { locale: enUS });
        var toLabel = format(toDate, 'MMM d', { locale: enUS });
        return "".concat(fromLabel, " - ").concat(toLabel);
    }
    var columns = __spreadArray([
        {
            title: t('app.performanceReview.employeePerformanceReview.communicationSection.tablesData.channel'),
            isVisible: true,
            className: 'min-w-0 !text-left'
        },
        {
            title: '',
            isVisible: true,
            className: 'min-w-0 !text-left'
        },
        {
            title: formatPeriod(dateFrom, dateTo),
            isVisible: true,
            colspan: 2,
            className: widgetMetricTablePairHeaderThClass
        }
    ], (userId
        ? [
            {
                title: t('app.performanceReview.employeePerformanceReview.communicationSection.tablesData.avgPerEmployee'),
                isVisible: true,
                colspan: 2,
                className: widgetMetricTablePairHeaderThClass
            }
        ]
        : []), true);
    var receivedColumns = columns;
    var data = buildCommunicationChannelTableRows({
        items: toCommunicationChannelTableItems((_b = communicationByChannel === null || communicationByChannel === void 0 ? void 0 : communicationByChannel.Initiated) !== null && _b !== void 0 ? _b : []),
        idPrefix: 'initiated',
        userId: userId,
        dateFrom: dateFrom,
        dateTo: dateTo,
        navigateToChannelEventsLog: navigateToChannelEventsLog,
        t: t
    });
    var receivedData = buildCommunicationChannelTableRows({
        items: toCommunicationChannelTableItems((_c = communicationByChannel === null || communicationByChannel === void 0 ? void 0 : communicationByChannel.Received) !== null && _c !== void 0 ? _c : []),
        idPrefix: 'received',
        userId: userId,
        dateFrom: dateFrom,
        dateTo: dateTo,
        navigateToChannelEventsLog: navigateToChannelEventsLog,
        t: t
    });
    return (_jsxs("div", __assign({ className: "flex flex-col gap-20 mt-5" }, { children: [_jsxs("div", __assign({ className: "w-full min-w-0" }, { children: [_jsx(WidgetTitle, { title: t('app.performanceReview.employeePerformanceReview.communicationSection.initiatedCommunicationByChannel'), description: t('widgetTitleDescriptions.communication.userInitiatedCommunication'), insightType: InsightTypeEnum.userInitiatedCommunication, insightsData: (_d = communicationByChannel === null || communicationByChannel === void 0 ? void 0 : communicationByChannel.Initiated) !== null && _d !== void 0 ? _d : [], refetch: refetch, csvExport: _jsx(ExportMenu, { fileName: t('app.performanceReview.employeePerformanceReview.communicationSection.initiatedCommunicationByChannel'), onExportHandler: function () { return __awaiter(void 0, void 0, void 0, function () { var _a; return __generator(this, function (_b) {
                                return [2 /*return*/, buildChannelExportRows((_a = communicationByChannel === null || communicationByChannel === void 0 ? void 0 : communicationByChannel.Initiated) !== null && _a !== void 0 ? _a : [])];
                            }); }); }, disabled: isAiButtonDisabled((_e = communicationByChannel === null || communicationByChannel === void 0 ? void 0 : communicationByChannel.Initiated) !== null && _e !== void 0 ? _e : []) }) }), _jsx(Table, { columns: columns, data: isInsightsDataEmpty((_f = communicationByChannel === null || communicationByChannel === void 0 ? void 0 : communicationByChannel.Initiated) !== null && _f !== void 0 ? _f : [])
                            ? []
                            : data, columnColStyles: channelTableColStyles, tableClassName: communicationByChannelTableClassName(userId), rowClassName: "[&>td]:align-top" })] })), _jsxs("div", __assign({ className: "w-full min-w-0" }, { children: [_jsx(WidgetTitle, { title: t('app.performanceReview.employeePerformanceReview.communicationSection.receivedCommunicationByChannel'), description: t('widgetTitleDescriptions.communication.userReceivedCommunication'), insightType: InsightTypeEnum.userReceivedCommunication, insightsData: (_g = communicationByChannel === null || communicationByChannel === void 0 ? void 0 : communicationByChannel.Received) !== null && _g !== void 0 ? _g : [], refetch: refetch, csvExport: _jsx(ExportMenu, { fileName: t('app.performanceReview.employeePerformanceReview.communicationSection.receivedCommunicationByChannel'), onExportHandler: function () { return __awaiter(void 0, void 0, void 0, function () { var _a; return __generator(this, function (_b) {
                                return [2 /*return*/, buildChannelExportRows((_a = communicationByChannel === null || communicationByChannel === void 0 ? void 0 : communicationByChannel.Received) !== null && _a !== void 0 ? _a : [])];
                            }); }); }, disabled: isAiButtonDisabled((_h = communicationByChannel === null || communicationByChannel === void 0 ? void 0 : communicationByChannel.Received) !== null && _h !== void 0 ? _h : []) }) }), _jsx(Table, { columns: receivedColumns, data: isInsightsDataEmpty((_j = communicationByChannel === null || communicationByChannel === void 0 ? void 0 : communicationByChannel.Received) !== null && _j !== void 0 ? _j : [])
                            ? []
                            : receivedData, columnColStyles: channelTableColStyles, tableClassName: communicationByChannelTableClassName(userId), rowClassName: "[&>td]:align-top" })] })), _jsx(EmailSummaryReplyRate, { userId: userId, orgUnitId: orgUnitId, dateFrom: dateFrom, dateTo: dateTo }), communicationByChannel && (_jsx(SentVSReceivedRatio, { refetch: refetch, data: communicationByChannel, dateFrom: dateFrom, dateTo: dateTo, userId: userId, orgUnitId: orgUnitId }))] })));
};
